import { createContext, useContext } from 'react';

const PronunciationCheckContext = createContext(null);

const usePronunciationContext = () => {
  const context = useContext(PronunciationCheckContext);
  if (context === null) {
    throw new Error(
      'usePronunciationContext must be used within a PronunciationProvider',
    );
  }
  return context;
};

export { PronunciationCheckContext, usePronunciationContext };
